import React from 'react';
import moment from 'moment';
import { translate } from 'react-i18next';

// Components
import ReactTooltip from 'react-tooltip';

// Constants & Services
import { userVerifyStatuses } from 'src/views/practitioner/services/practitionerConstants';

// Styles
import { FullName, GreenCircle, New, PersonInfo } from './tableStyles';

export default translate()(props => {
  const { i18n, patient } = props;

  return patient ? (
    <React.Fragment>
      <div style={{ position: 'relative' }}>
        {patient.isUmbi && (
          <GreenCircle
            data-for="patient-info-tooltip"
            data-tip={i18n.t(userVerifyStatuses[patient.status])}
            className={patient.status}
          />
        )}
        <ReactTooltip id="patient-info-tooltip" type="light" border={true} />

        <FullName>
          <span>{patient.lastName}</span>
          <span>{patient.firstName}</span>
        </FullName>
      </div>
      <PersonInfo className="personal-info">
        {`${moment(patient.birthDate).format('DD.MM.YYYY')} | ${i18n.t(
          patient.gender ? `gender_${patient.gender.toLowerCase()}` : 'no_data'
        )}`}
        {patient.isNew && (
          <span>
            {' '}
            | <New>{i18n.t('new')}</New>
          </span>
        )}
      </PersonInfo>
    </React.Fragment>
  ) : null;
});
